"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FieldAlert = FieldAlert;

var _collapse = require("../collapse");

var _media = require("react-components/media");

var _typography = require("../typography");

var _styles = require("react-components/styles");

var _styledTools = require("styled-tools");

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Module dependencies.
 */
var formErrorIcon = "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 16 16\"><g stroke=\"currentColor\"><path d=\"M2.29 12.64c1.982 2.796 9.44 2.794 11.42 0 .638-.898.957-2.443.957-4.633s-.32-3.736-.957-4.634C11.794.671 4.257.49 2.29 3.263c-.637.899-.957 2.48-.957 4.744 0 2.19.32 3.735.957 4.633z\"/><path stroke-miterlimit=\"10\" d=\"M8.86 9.275c-.297-.434-1.423-.434-1.72 0-.089.137-.137.378-.137.724 0 .345.048.579.137.715.29.418 1.423.45 1.72.016.089-.136.137-.386.137-.731 0-.346-.048-.587-.137-.724zM8 4.78v3.216\"/></g></svg>";
var infoIcon = "<svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 16 16\"><path d=\"M13.71 3.86c-1.982-2.796-9.44-2.794-11.42 0-.638.898-.957 2.443-.957 4.633s.32 3.736.957 4.634c1.916 2.702 9.453 2.883 11.42.11.637-.899.957-2.48.957-4.744 0-2.19-.32-3.735-.957-4.633z\"/><path stroke-miterlimit=\"10\" d=\"M7.14 7.225c.297.434 1.423.434 1.72 0 .089-.137.137-.378.137-.724 0-.345-.048-.579-.137-.715-.29-.418-1.423-.45-1.72-.016-.089.136-.137.386-.137.731 0 .346.048.587.137.724zM8 11.72V8.504\"/></svg>";
var successIcon = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><g fill=\"none\" stroke=\"currentColor\"><path d=\"M13.7 3.4C11.7.6 4.3.6 2.3 3.4c-.6.9-1 2.4-1 4.6 0 2.2.3 3.7 1 4.6 1.9 2.7 9.5 2.9 11.4.1.6-.9 1-2.5 1-4.7s-.4-3.7-1-4.6z\"/><path d=\"M10.8 6.3L8 9.4c-.2.2-.5.3-.8.3h-.4c-.3 0-.6-.2-.8-.4l-.9-1\" stroke-miterlimit=\"10\"/></g></svg>";
var warningIcon = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><g fill=\"none\" stroke=\"currentColor\" stroke-miterlimit=\"10\"><path d=\"M9.2 10c-.4-.6-2-.6-2.4 0-.1.2-.2.5-.2 1s.1.8.2 1c.4.6 2 .6 2.4 0 .1-.2.2-.5.2-1s-.1-.8-.2-1z\"/><path d=\"M1 12.8c-.2-.4-.2-.9 0-1.3l2.7-4.6 2.7-4.6c.1-.5.6-.7 1-.7h1.1c.5 0 .9.2 1.1.6l2.7 4.6 2.7 4.6c.2.4.2.9 0 1.3l-.6 1c-.2.4-.7.6-1.1.6H2.7c-.5 0-.9-.2-1.1-.6l-.6-.9z\"/><path d=\"M1 12.8c-.2-.4-.2-.9 0-1.3l2.7-4.6 2.7-4.6c.1-.5.6-.7 1-.7h1.1c.5 0 .9.2 1.1.6l2.7 4.6 2.7 4.6c.2.4.2.9 0 1.3l-.6 1c-.2.4-.7.6-1.1.6H2.7c-.5 0-.9-.2-1.1-.6l-.6-.9zm7-9v4.4\"/></g></svg>";
/**
 * `Props` type.
 */

/**
 * Icons.
 */
var icons = {
  error: formErrorIcon,
  info: infoIcon,
  success: successIcon,
  warning: warningIcon
};
/**
 * `Content` styled component.
 */

var Content = _styledComponents["default"].div.withConfig({
  displayName: "field-alert__Content",
  componentId: "sc-1a19fgu-0"
})(["border-radius:8px;margin:4px 0 0;padding:4px 12px;transition:", ";transition-property:background-color,color;", " ", ""], (0, _styledTools.theme)('transitions.defaultTransition'), (0, _styledTools.ifProp)('hasIcon', (0, _styledComponents.css)(["align-items:center;display:grid;grid-column-gap:8px;grid-template-columns:max-content 1fr;"])), (0, _styledTools.switchProp)('type', {
  "default": (0, _styledComponents.css)(["background-color:", ";color:", ";"], (0, _styles.color)('gray200'), (0, _styles.color)('gray900')),
  error: (0, _styledComponents.css)(["background-color:", ";color:", ";"], (0, _styles.color)('danger100'), (0, _styles.color)('danger')),
  info: (0, _styledComponents.css)(["background-color:", ";color:", ";"], (0, _styles.color)('info100'), (0, _styles.color)('info500')),
  success: (0, _styledComponents.css)(["background-color:", ";color:", ";"], (0, _styles.color)('success100'), (0, _styles.color)('success900')),
  warning: (0, _styledComponents.css)(["background-color:", ";color:", ";"], (0, _styles.color)('warning100'), (0, _styles.color)('warning700'))
}));
/**
 * `DefaulText` styled component.
 */


var DefaulText = (0, _styledComponents["default"])(_typography.Text).attrs({
  size: 'small'
}).withConfig({
  displayName: "field-alert__DefaulText",
  componentId: "sc-1a19fgu-1"
})(["font-size:14px;line-height:20px;"]);
/**
 * Export `FieldAlert` component.
 */

function FieldAlert(props) {
  var children = props.children,
      className = props.className,
      hasIcon = props.hasIcon,
      isOpen = props.isOpen,
      size = props.size,
      _props$type = props.type,
      type = _props$type === void 0 ? 'default' : _props$type;
  var icon = type === 'default' ? null : icons[type];
  return /*#__PURE__*/_react["default"].createElement(_collapse.Collapse, {
    isOpen: isOpen
  }, /*#__PURE__*/_react["default"].createElement(Content, {
    className: className,
    hasIcon: hasIcon,
    type: type
  }, hasIcon && icon && /*#__PURE__*/_react["default"].createElement(_media.Icon, {
    "aria-hidden": true,
    color: 'inherit',
    icon: icon,
    size: '16px'
  }), size ? /*#__PURE__*/_react["default"].createElement(_typography.Text, {
    size: size
  }, children) : /*#__PURE__*/_react["default"].createElement(DefaulText, null, children)));
}